import settings from '@modules/config/settings';
import type Feature from '../interfaces/Feature';

export const articlesPage: Feature = {
  key: 'guides',
  titleKey: 'Guides',
  category: '/',
  path: '/getting-started',
};

export const engineAPIPage: Feature = {
  key: 'engineAPI',
  titleKey: 'EngineAPI',
  category: '/reference/engine',
  path: '/reference/engine',
};

export const educationPage: Feature = {
  key: 'education',
  titleKey: 'Education',
  category: '/education',
  path: '/education/support/education-getting-started',
};

export const cloudAPIPage: Feature = {
  key: 'cloudAPI',
  titleKey: 'CloudAPI',
  category: '/reference/cloud',
  path: '/reference/cloud',
};

export const communityPage: Feature = {
  key: 'community',
  titleKey: 'Community',
  category: '/community',
  path: '/community',
};

export const featuresTabs: Feature[] = [articlesPage, engineAPIPage];

featuresTabs.push(cloudAPIPage);
featuresTabs.push(educationPage);
if (settings.enableCommunityContent) {
  featuresTabs.push(communityPage);
}
